<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">{{ title }}</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            <a routerLink="/dashboard/client" class="d-inline-block position-relative">
                <i class="ri-home-8-line"></i> Home
            </a>
        </li>
        <li *ngIf="section" class="breadcrumb-item position-relative">{{ section }}</li>
        <li class="breadcrumb-item position-relative">{{ title }}</li>
    </ol>
</div>

<!-- Placeholder Card -->
<div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
        <div class="text-center" style="padding: 60px 20px;">
            <i class="material-symbols-outlined" style="font-size:72px; color:#ccc;">construction</i>
            <h3 class="mt-20 mb-10 fw-semibold">{{ title }}</h3>
            <p class="text-muted mb-20">This page is under construction and will be built out as part of the Simplified 2026 rebuild.</p>
            <span class="badge text-white" style="background-color: #757fef; font-size: 13px; padding: 8px 16px;">Coming Soon</span>
        </div>
    </div>
</div>
